import { Spinner } from '@cian/ui-kit';
import * as React from 'react';

import styles from './TabLoader.css';

export const TabLoader = () => {
  return (
    <div className={styles['wrapper']} data-testid="TabLoader">
      <Spinner size="medium" colorType="default" />
    </div>
  );
};
